export default __webpack_public_path__ + "static/media/metagate-satelite.4c292d4d.png";